import React, { useEffect } from 'react';

import { Drawer } from "@mui/material";
import clsx from 'clsx';
import CloseIcon from "@mui/icons-material/Close";
import { PrimaryNavbar } from "../Navbar/PrimaryNavbar";
import { PrimaryIconButton } from "../IconButton/PrimaryIconButton";
import { PrimaryTypography } from "../Typograhy/PrimaryTypography";
import customStyles from "../../../../assets/styles/customStyles";


export const PrimaryDrawer = props => {
    const { anchor, classes, component, elevation, footer, handleClose, open, width, title, variant, ...otherProps } = props
    const customClasses = customStyles();

    useEffect(() => {
        let el = document.getElementById('containerDiv');
        if (el) {
            el.scrollTo({
                top: el.scrollTop + 1,
                left: 0,
                behavior: "smooth",
            });
        }
    }, [open]);

    return (
        <>
            <Drawer
                anchor={anchor || 'right'}
                classes={{ root: classes }}
                elevation={elevation || 16}
                open={open || false}
                variant={variant || 'temporary'}
                onClose={handleClose}
                footer={footer}
                {...otherProps}
                PaperProps={{
                    sx: { width: width ? width : '360px' },
                }}
            >
                <PrimaryNavbar
                    color={'primary'}
                    position={'static'}
                    variant={'regular'}
                    className={clsx(customClasses.primaryNavbar, customClasses.closeBackGround)}
                    component={
                        <>
                            <PrimaryTypography
                                align={'left'}
                                classes={clsx(customClasses.margin8, customClasses.fonSize16, customClasses.widthFull, customClasses.bold, customClasses.textCapital)}
                                variant={'h6'}
                                textValue={title}
                            />
                            <PrimaryIconButton
                            tabIndex={-1}
                                aria-label={'back'}
                                disabled={false}
                                edge={'end'}
                                size={'large'}
                                handleClose={handleClose}
                                iconComponent={<CloseIcon
                                  
                                    />}
                            />
                        </>
                    }
                />
                {component}
            </Drawer>
        </>
    )
}